<script lang="ts">
    import PageDeliveryList2 from './PageDeliveries2/PageDeliveryList2.svelte';

    export let id: number;
</script>

<PageDeliveryList2 {id} />
